import {createAction, props} from "@ngrx/store";
import {NotificationRole} from "../ek-models/NotificationRole";

export const notificationManagementPageRequested = createAction('[notification Management List Page] notification Management  Page Requested ');
export const notificationManagementPageLoadedSuccessfully = createAction('[notification Management  API] notification Management  Page Loaded Successfully ', props<{ notificationListing: NotificationRole[], totalCount: number, page: number }>());
export const notificationManagementPageLoadFailed = createAction('[notification Management  API] notification Management  Page Request Failed ', props<{ error: any }>());

